"use strict";
$(function ($) {
  /* ドロワーメニュー */
  /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
    $('.header__logo').toggleClass('active'); // header__logo に active クラスを付与/削除
    $('.header__sub').toggleClass('active'); // header__sub に active クラスを付与/削除

    // bodyのスクロールを制御する
    if ($('#js-drawer-menu').hasClass('is-openSP')) {
      $('body').css('overflow', 'hidden'); // メニューが開いたらスクロール禁止
    } else {
      $('body').css('overflow', ''); // メニューが閉じたらスクロール許可
    }
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内のリンクをクリックしたらメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click');
  });
});

